import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import kitchenImage from '../../../../images/raw_material/rice.png'; // placeholder image

const KitchenRoomModal = ({ show, onClose }) => {
    const tableRef = useRef(null);
    const [stockData, setStockData] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;  

    // Fetch kitchen stock data
    const fetchKitchenStock = async () => {
        try {
            const res = await fetch(`${baseURL}/kitchen-stock`);
            const data = await res.json();
            if (data.status === 'success') {
                setStockData(data.data);
            }
        } catch (err) {
            console.error(err);
            setStockData([]);
        }
    };

    useEffect(() => {
        if (show) fetchKitchenStock();
    }, [show]);

    // Initialize DataTable
    useEffect(() => {
        if (tableRef.current && stockData.length > 0) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    responsive: true,
                    ordering: false,
                    paging: false,
                    scrollY: "250px",
                    scrollCollapse: true,
                    language: { lengthMenu: "Show _MENU_" },
                    dom:
                        "<'row'< 'col-sm-12 d-flex align-items-center justify-content-end mb-2'f > >" +
                        "<'table-responsive'tr>" +
                        "<'row'< 'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i > >"
                });
            }
        }
    }, [stockData]);

    return ( 
        <Modal show={show} size="lg" >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Kitchen Room Details</h3>
                    <Button variant="" type="button" className="close px-6 py-1" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="table-container">
                        <table  className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-100px text-start'>Raw Material</th>
                                    <th className='min-w-100px text-center'>Stock Quantity</th>
                                    <th className='min-w-100px text-center'>Consumption Quantity</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {stockData.length > 0 ? stockData.map((item, idx) => (
                                    <tr key={idx}>
                                        <td className='text-black'>{item.raw_material_name || '-'}</td>
                                        <td className='text-black text-center'>{item.stock_quantity} {item.stock_unit || '-'}</td>
                                        <td className='text-black text-center'>
                                        {item.stock_cons_quantity && item.stock_cons_unit 
                                            ? `${item.stock_cons_quantity} ${item.stock_cons_unit}` 
                                            : '-'}
                                        </td>

                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">No records found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default KitchenRoomModal;
